<template>
  <div class="reverso-user-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-col :span="24">
        <el-form-item label="用户类型">
          <el-select v-model="queryParams.userType" size="small" clearable placeholder="请选择用户类型">
            <el-option
                v-for="subItem in enumUser"
                :key="subItem.value"
                :label="subItem.name"
                :value="subItem.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="queryParams.userName" size="small" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="产品类型">
            <el-select v-model="queryParams.productType" size="small" clearable placeholder="请选择产品类型">
              <el-option
                  v-for="subItem in enumProduct"
                  :key="subItem.value"
                  :label="subItem.name"
                  :value="subItem.value"/>
            </el-select>
          </el-form-item>
        <el-form-item label="用户地址">
          <el-input v-model="queryParams.address" size="small" placeholder="请输入用户地址"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="24">
        <el-form-item label="销售时间">
          <el-date-picker
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" round icon="el-icon-search" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
        </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="userName"
              show-overflow-tooltip
              align="center"
              width="100"
              label="用户名称">
          </el-table-column>
          <el-table-column
              prop="userType"
              show-overflow-tooltip
              align="center"
              width="100"
              label="用户类型">
          </el-table-column>
          <el-table-column
              prop="userPhone"
              show-overflow-tooltip
              align="center"
              width="150"
              label="联系电话">
          </el-table-column>
          <el-table-column
              prop="userAddr"
              show-overflow-tooltip
              align="center"
              width="200"
              label="地址">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              width="200"
              label="产品名称">
          </el-table-column>
          <el-table-column
              prop="waterPumpCode"
              show-overflow-tooltip
              align="center"
              width="300"
              label="水泵码">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              width="160"
              label="填写时间">
          </el-table-column>
          <el-table-column
              prop="desct"
              show-overflow-tooltip
              align="center"
              width="300"
              label="备注">
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent($event,1)"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            layout="total, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
  </div>
</template>

<script>

import {getTemplateUser} from "../../utils/interface";

export default {
  components: {},
  data() {
    return {
      tableData: [],
      queryParams: {
        userName: '',
        userType: '',
        productType: '',
        address: '',
        startTime: '',
        endTime: '',
        current: 1,
        pageSize: 5,
        total: 0,
      },
      enumUser: [{
        value: '个人',
        name: '个人',
      }, {
        value: '公司',
        name: '公司',
      }, {
        value: '政府',
        name: '政府',
      }, {
        value: '事业单位',
        name: '事业单位',
      }],
      enumProduct: [{
        value: '-1',
        name: '请选择',
      }],
      listLoading: false,
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      getTemplateUser(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        userName: '',
        userType: '',
        productType: '',
        address: '',
        startTime: '',
        endTime: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e, type) {
      if (type === 1) {
        this.queryParams.current = e
        this.getPageList()
      }
    },
    eachDictName(status) {
      return this.enumUser.find(item => item.value === status).name
    },
  },
};
</script>

<style scoped lang="less">
.reverso-user-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoUserList.vue